import { message } from "ant-design-vue";
import { getTimeZone } from "@/src/utils/utils.js";

export const showExportLoadingMessage = (content = "Initiating export...") => {
  message.loading({ content, key: "exportCSV" });
};

export const showExportSuccessMessage = (content = "Export initiated successfully. You will receive an email shortly.") => {
  message.success({
    content,
    key: "exportCSV",
    duration: 5,
  });
};

export const showExportErrorMessage = (error, defaultMessage = "Failed to initiate export. Please try again.") => {
  const errorMessage = error?.response?.data?.error || error?.error || error?.message || defaultMessage;
  message.error({
    content: errorMessage,
    key: "exportCSV",
    duration: 5,
  });
};

export const getBrowserTimezone = () => {
  return getTimeZone();
};

export const calculateDateRangeFromDays = (days) => {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - days);
  
  return {
    start_time: startDate.toISOString(),
    end_time: endDate.toISOString(),
  };
};

export const buildDateFiltersFromRange = (dateRange) => {
  const filters = {};
  
  if (dateRange?.startDate && dateRange?.endDate) {
    filters.start_time = new Date(dateRange.startDate).toISOString();
    filters.end_time = new Date(dateRange.endDate).toISOString();
  } else if (dateRange?.start && dateRange?.end) {
    filters.start_time = dateRange.start;
    filters.end_time = dateRange.end;
  }
  
  return filters;
};

export const buildFiltersFromStore = (storeGetters) => {
  const filters = {};
  const range = storeGetters["analytics/getRange"];
  const userIds = storeGetters["analytics/getUserIds"];
  const teamIds = storeGetters["analytics/getTeamIds"];
  
  if (userIds && userIds.length > 0) {
    filters.user_ids = userIds;
  }
  if (teamIds && teamIds.length > 0) {
    filters.team_ids = teamIds;
  }
  if (range?.start) {
    filters.start_time = range.start;
  }
  if (range?.end) {
    filters.end_time = range.end;
  }
  
  return filters;
};

export const handleExportResponse = (response, onSuccess) => {
  if (response.success) {
    showExportSuccessMessage();
    if (onSuccess) onSuccess();
    return true;
  } else {
    showExportErrorMessage(response);
    return false;
  }
};

export const executeExport = async (exportFn, onSuccess) => {
  try {
    showExportLoadingMessage();
    const response = await exportFn();
    return handleExportResponse(response, onSuccess);
  } catch (error) {
    console.error("Export error:", error);
    showExportErrorMessage(error);
    return false;
  }
};
